import { useStyles } from './useStyles';
import Header from '@components/Header';
import Footer from '@components/Footer';
import { Typography } from '@mui/material';
import theme from 'src/style-system/theme';
import ExitIntent from '@components/ExitIntent';
import Carousel from './Carousel';
import { carouselContent } from './constant';

const Reviews = () => {
  const classes = useStyles();
  return (
    <div>
      {/* <ExitIntent /> */}
      <div className={classes.upperSection}>
        <Header isBackground={false} fill={theme.palette.turmeric.main} />
        <Carousel carouselContent={carouselContent} />
      </div>
      <Typography
        variant="h2"
        color="cinnamon.main"
        align="center"
        sx={{
          margin: '50px 0 20px 0',
        }}
      >
        All Reviews
      </Typography>
      <iframe
        src="https://reviews.thecuminclub.com/reviews"
        width="100%"
        height="2585px"
        style={{ border: 'none' }}
      />
      <Footer />
    </div>
  );
};

export default Reviews;
